/* eslint-disable no-param-reassign */
/**
 * EqualHeight component.
 * All DOM elements with classname '.js-equal-height' are wrappers for a group that needs to be equal heighted.
 * On a debounced resize event, the heights will be recalculated.
 *
 * Usage:
 * Call EqualHeight.init() to initialize all $equalHeightWrappers.
 *
 * Methods:
 *
 * init(): attaches eventlisteners to all $equalHeightWrappers
 */

const debounce = require('../helpers/debounce');

const removeStaticHeights = $items => {
	$items.forEach($i => {
		$i.style.height = '';
	});
};

const setStaticHeights = ($items, height) => {
	$items.forEach($i => {
		$i.style.height = `${height}px`;
	});
};

const calculateHeights = function($equalHeightWrappers) {
	$equalHeightWrappers.forEach($wrapper => {
		const heights = [];
		const $items = $wrapper.querySelectorAll('[data-equal-height]');

		removeStaticHeights($items);
		$items.forEach($i => {
			heights.push($i.scrollHeight);
		});
		const highestHeight = Math.max(...heights);
		setStaticHeights($items, highestHeight);
	});
};

const init = () => {
	const $equalHeightWrappers = document.querySelectorAll('.js-equal-height');

	// On debounced window resize, recalculate heights
	function onResize() {
		calculateHeights($equalHeightWrappers);
	}
	const debounced = debounce(onResize, 300);
	window.addEventListener('resize', debounced);

	// Calculate initial
	calculateHeights($equalHeightWrappers);
};

module.exports = {
	init
};
